module.exports = __webpack_public_path__ + "assets/img/teacher (47).0b39e3ba.png";